<template>
  <div class="pr">
    <div class="tabs" :style="{ height: status ? 'auto' : '40px' }">
      <div class="symbol_tab_disable">正在聊：</div>
      <div
        v-for="(item, index) in list"
        :key="index"
        class="symbol_tab"
        :class="{ symbol_tab_active: currentTabIndex == index }"
        @click="changTabs(index)"
      >
        {{ item.symbol_name }}
      </div>

      <div v-if="showMoreBtn" class="symbol_tab_more" @click="changeStatus">
        <el-icon v-if="!status"><ArrowDown /></el-icon>
        <el-icon v-else><ArrowUp /></el-icon>
      </div>
    </div>
    <!-- 隐藏傀儡用于计算真实高度 -->
    <div ref="tabs_box" class="tabs_box">
      <div class="tabs">
        <div class="symbol_tab_disable">正在聊：</div>
        <div v-for="(item, index) in list" :key="index" class="symbol_tab">
          {{ item.symbol_name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";
export default {
  data() {
    return {
      currentTabIndex: 0,
      status: false,
      list: [],
      circle_id: null,
      teacher_id: null,
      showMoreBtn: false,
    };
  },
  watch: {
    list: {
      deep: true,
      handler(newValue) {
        setTimeout(() => {
          // console.error('=====newValue', this.$refs.tabs_box.clientHeight, newValue)
          this.showMoreBtn = this.$refs.tabs_box.clientHeight > 40;
        });
      },
    },
  },
  methods: {
    init(e) {
      this.currentTabIndex = 0;
      const list = [
        {
          symbol: "",
          symbol_name: "全部",
        },
      ];
      this.list = list.concat(e.symbolList);
      this.circle_id = e.circle_id;
      this.teacher_id = e.teacher_id;
      this.status = false;
    },
    changeStatus() {
      this.status = !this.status;
    },
    changTabs(index) {
      this.currentTabIndex = index;
      this.$parent.getChatMessageList1({
        circle_id: this.circle_id,
        teacher_id: this.teacher_id,
        symbol: this.list[this.currentTabIndex].symbol,
      });
    },
    pushSymbolList(e) {
      const list = this.list;
      if (!list.filter((item) => item.symbol === e.symbol).length) {
        this.list.push({
          symbol: e.symbol,
          symbol_name: e.symbol_name,
          teacher_id: e.teacher_id,
        });
      }
    },
  },
};
</script>

<style scoped>
.tabs_box {
  position: absolute;
  left: -5000px;
  top: -5000px;
  width: 100%;
}

.tabs {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  box-sizing: border-box;
  padding: 8px 36px 8px 16px;
  background-color: #f9f9f9;
  overflow: hidden;
  transition: all 0.2s;
}

.symbol_tab {
  height: 24px;
  border-radius: 40px;
  border: 1px solid #dfdfdf;
  box-sizing: border-box;
  padding: 0 14px;
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 12px;
  color: #666666;
  cursor: pointer;
  user-select: none;
  flex-shrink: 0;
}

.symbol_tab:hover {
  color: #4571e7;
  border: 1px solid #4571e7;
}

.symbol_tab_disable {
  height: 24px;
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 12px;
  color: #333333;
}

.symbol_tab_active {
  font-weight: 400;
  font-size: 12px;
  color: #ffffff !important;
  background-color: #4571e7;
  border: 1px solid #4571e7;
}

.symbol_tab_more {
  position: absolute;
  right: 16px;
  cursor: pointer;
  user-select: none;
}
</style>
